import React from "react";
import myPhoto from "../assets/myphoto.jpg";
import "animate.css";
import Tools from "./Tools";
import Projects from "./Projects";
import Contact from "./Contact";

const About = () => {
  return (
    <div>
      <div
        className="two-column-container animate__animated animate__fadeIn"
        id="about-section"
      >
        <div className="left-column">
          <img src={myPhoto} alt="Your Alt Text" />
        </div>
        <div className="right-column">
          <h1>May's Story .</h1>
          <p>
            {" "}
            Hey there! I'm May Phoo Pyae San, a budding web developer based in
            the beautiful city of Mandalay. I'm 22 years young and absolutely
            passionate about creating awesome things on the web! I find joy in
            crafting immersive web experiences and bringing ideas to life
            through elegant code. <br />{" "}
            <span
              style={{
                fontSize: "1rem",
                color: "#edc74b",
                marginTop: "0rem",
                fontFamily: "Space Mono, monospace",
              }}
            >
              Silly Secrets Session: lowkey want to be a writer and dancer.
            </span>
          </p>

          <a
            href="https://firebasestorage.googleapis.com/v0/b/portfolio-e38aa.appspot.com/o/MayPhooPyaeSan-CVForm.pdf?alt=media&token=8414b9bc-034e-48d8-a9c4-54aa14a4b275"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn">View CV</button>
          </a>
        </div>
      </div>
      <Tools />
      <Projects />
      <Contact />
    </div>
  );
};

export default About;
